import {
  MINIMUM_SLIDER_PRICE,
  priceRangeSliderMarks,
} from '@/components/discovery-questions-input/utils/price-range-slider-marks';
import { MINIMUM_SLIDER_YEAR, yearSliderMarks } from '@/components/discovery-filter/constants';
import { type Lifestyle } from '@/constants/lifestyle-preferences';
import { type BodyStyle } from '@/constants/body-styles';
import { type PowerType } from '@/components/discovery-questions-input/utils/update-power-type-state/types';

export type FiltersState = {
  selectedBodyStyles: BodyStyle[];
  selectedLifestyles: Lifestyle[];
  selectedMakes: string[];
  selectedStarRatings: string[];
  selectedSafetyFeatures: string[];
  selectedPowerTypes: PowerType[];
  selectedPriceRange: [number, number];
  uiSelectedPriceRange: [number, number];
  selectedYearRange: [number, number];
  uiSelectedYearRange: [number, number];
};

const defaultPriceRange: [number, number] = [MINIMUM_SLIDER_PRICE, priceRangeSliderMarks.at(-1)?.value as number];
const defaultYearRange: [number, number] = [MINIMUM_SLIDER_YEAR, yearSliderMarks.at(-1)?.value as number];

const state: FiltersState = {
  selectedBodyStyles: [],
  selectedLifestyles: [],
  selectedMakes: [],
  selectedStarRatings: [],
  selectedSafetyFeatures: [],
  selectedPowerTypes: [],
  selectedPriceRange: [...defaultPriceRange],
  uiSelectedPriceRange: [...defaultPriceRange],
  selectedYearRange: [...defaultYearRange],
  uiSelectedYearRange: [...defaultYearRange],
};

export default state;
